module.exports = __webpack_public_path__ + "img/2015.194b9811.png";